import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';

export const DashboardSummaryAlertFilledIconGroup: React.FC<SvgProps> = (
  props,
) => {
  return (
    <g fill="none" {...(props.group ?? {})}>
      <circle cx="8" cy="8" r="8" fill="#D41515" />
      <rect x="7.25" y="3.5" width="1.5" height="6" rx="0.75" fill="white" />
      <circle cx="8" cy="11.75" r="1" fill="white" />
    </g>
  );
};

export const DashboardSummaryAlertFilledIconSvg: React.FC<SvgProps> = (
  props,
) => {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...(props.svg ?? {})}
    >
      <DashboardSummaryAlertFilledIconGroup {...props} />
    </svg>
  );
};
